// src/services/bank.service.ts
import api from './api';
import axios from 'axios';

export interface Bank {
  id: number;
  name: string;
  code: string;
  slug?: string;
  longcode?: string;
  gateway?: string | null;
  pay_with_bank?: boolean;
  active: boolean;
  country: string;
  currency: string;
  type: string;
  createdAt?: string;
  updatedAt?: string;
}

interface BanksResponse {
  status: boolean;
  message: string;
  data: Bank[];
}

interface ApiError {
  response?: {
    status: number;
    data: any;
  };
  message: string;
}

const BankService = {
  /**
   * Get list of supported banks from the backend
   * @param country Country code (nigeria, ghana, kenya)
   * @returns List of banks
   */
  getBanks: async (country = 'nigeria'): Promise<Bank[]> => {
    try {
      console.log('Fetching banks from API...');
      const response = await api.get<BanksResponse>('/payments/banks', {
        params: { country }
      });
      
      console.log(`Retrieved ${response.data.data.length} banks`);
      return response.data.data;
    } catch (error: unknown) {
      console.error('Error fetching banks:', error);
      
      // Type guard for axios errors
      if (axios.isAxiosError(error)) {
        const axiosError = error as ApiError;
        if (axiosError.response) {
          console.error('Response status:', axiosError.response.status);
          console.error('Response data:', axiosError.response.data);
        }
      }
      
      return [];
    }
  },
  /**
 * Resolve account number with bank to verify and get account name
 * @param accountNumber The 10-digit NUBAN account number
 * @param bankCode The bank code from Paystack
 * @returns Account details if verification successful
 */
resolveAccountNumber: async (accountNumber: string, bankCode: string) => {
  try {
    const response = await api.post('/payments/resolve-account', {
      accountNumber,
      bankCode
    });
    return response.data;
  } catch (error) {
    console.error('Error resolving account number:', error);
    throw error;
  }
}
  
};


export default BankService;